import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { CAutocomplete } from '@web-kc/shared/components';
import { useTranslation } from 'next-i18next';
import { useFilters } from '../../Provider';

const LotInitiator: React.FC = () => {
  const { t } = useTranslation('tenders');
  const { selectedFilters, setField, employees } = useFilters();

  const handleChange = (newValue: number) => {
    setField('person', newValue ? Number(newValue) : undefined);
  };

  return (
    <Stack
      direction={{ lg: 'row', md: 'column', xs: 'column' }}
      alignItems="flex-start"
      gap={2.5}
      mt={3}
    >
      <Typography fontWeight={700} maxWidth="120px" width="100%">
        {t('tenders.modal.initiator')}
      </Typography>
      <Stack flexWrap="wrap" direction="row" gap={1.25} width="100%">
        <Box width="100%">
          <CAutocomplete
            fullWidth
            options={employees?.content ?? []}
            optionValueKey="personId"
            optionLabelKey="name"
            value={selectedFilters.person}
            onChange={(newValue) => handleChange(newValue)}
            clearable
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default LotInitiator;
